export default __webpack_public_path__ + "static/media/icon-filetype-attachments.2b9f5b9d.svg";